export default __webpack_public_path__ + "ee2ea9ba57c0d6fceeac816ccf5b0459.png";